import React from 'react';
import { motion } from 'framer-motion';
import { InView } from './InView';
import { BOOKING_URL } from './BookMeetingButton';

/** Closing invitation: book a personal walkthrough of the IVF Pulse experiences. */
export function WalkthroughInvite() {
  return <InView delay={0.2} data-id="element-704" data-mp="amwdvlrbwmx0">
      <div className="relative mt-20 overflow-hidden rounded-[32px] bg-[var(--fg)] px-6 py-14 text-center sm:px-12 sm:py-20" data-id="element-705" data-mp="fjmrm2fnv6f9">
        <div aria-hidden="true" className="pointer-events-none absolute -left-24 -top-24 h-[340px] w-[340px] rounded-full bg-[var(--brand)]/25 blur-[100px]" data-id="element-706" data-mp="txlrtwmie8n" />
        <div aria-hidden="true" className="pointer-events-none absolute -bottom-24 -right-24 h-[340px] w-[340px] rounded-full bg-[#E8A92E]/15 blur-[100px]" data-id="element-707" data-mp="3nzoleaa11p81" />

        <div className="relative" data-id="element-708" data-mp="3szawad2dutdo">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.18em] text-white/80" data-id="element-709" data-mp="3e1ijhso80j36">
            <span className="h-1.5 w-1.5 rounded-full bg-[#E8A92E]" aria-hidden="true" data-id="element-710" data-mp="3j03m1yqy3eus" />
            The IVF Pulse · ESHRE 2027
          </span>
          <h2 className="mx-auto mt-6 max-w-[18ch] text-[38px] font-extrabold leading-[1] tracking-[-0.045em] text-white sm:text-[60px] xl:text-[72px]" data-id="element-711" data-mp="10omuho85d31p">
            Curious to see the IVF Pulse <span className="text-[var(--brand-lighter)]" data-id="element-712" data-mp="1elt8z6lu8fl4">in action?</span>
          </h2>
          <p className="mx-auto mt-6 max-w-[52ch] text-[17px] leading-relaxed text-white/75" data-id="element-713" data-mp="1akg1yt70e6cm">
            We’ve created three bespoke interactive experiences to bring this campaign to life. We’d love to walk you
            through them.
          </p>

          <motion.a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.97
        }} aria-label="Experience the IVF Pulse — book a short personal walkthrough (opens in a new tab)" className="mt-10 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-[16px] font-extrabold text-[var(--fg)] shadow-[0_24px_50px_-20px_rgba(0,0,0,0.6)] transition-colors hover:bg-[var(--brand-lighter)] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--fg)] sm:text-[18px]" data-id="element-714" data-mp="vpjr087tf4vu">
            Experience the IVF Pulse →
          </motion.a>
          <p className="mt-4 text-[13px] font-medium text-white/55" data-id="element-715" data-mp="2d2w3zk7yy0sv">Book a short personal walkthrough.</p>
        </div>
      </div>
    </InView>;
}